import React from 'react';
import Link from '~/components/molecule/Link';
import Markdown from '~/components/molecule/Markdown';
import {
  Body,
  Heading2,
  Heading3,
  Heading4,
  Strong,
  Variant,
} from '~/components/atom/Typography';
import styled, { css } from 'styled-components';

export type Props = {
  dataTestId?: string;
  value: string;
};

const LfaMarkdown: React.FC<Props> = ({ value }) => (
  <Container>
    <Markdown
      value={value}
      options={{
        remarkReactComponents: getComponents(),
      }}
    />
  </Container>
);

const Container = styled.div<{}>(
  ({}) => css`
    min-width: 300px;
    max-width: 100%;
    word-break: break-word;
  `,
);

export default LfaMarkdown;

const getComponents = () => ({
  h1: props => (
    <Heading2
      {...props}
      variant={Variant.primary}
      color={{ group: 'primary' }}
      fontWeight="semiBold"
      size="m"
    />
  ),
  h2: props => (
    <Heading3
      {...props}
      fontWeight="semiBold"
      color={{ group: 'secondary' }}
      size="base"
    />
  ),
  h3: props => (
    <Heading4
      {...props}
      size="base"
      color={{ group: 'primary', variant: 'light' }}
    />
  ),
  strong: props => (
    <Strong
      {...props}
      color={{ group: 'secondary' }}
      style={{ fontSize: 'inherit' }}
    />
  ),
  p: props => <Body size="base" {...props} />,
  a: props => <StyledLink {...props} to={props.href} />,
});

const StyledLink = styled(Link)(
  ({ theme }) => css`
    color: ${theme.color('secondary')};
  `,
);
